import { Component} from '@angular/core';
import { Localization } from "../../enums/localization";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  public readonly Localization = Localization;
}
